export default {"src":"/_next/static/media/PersonalId_Passport.fe26ba98.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};